// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__8pDhG","loader":"Loader_loader__A1grY","loader_square":"Loader_loader_square__OPotz","square-animation":"Loader_square-animation__6spa7"};